import { createSelector } from 'reselect';

import mainSelect from './mainSelector';
import secondarySelect from './secondarySelector';
import {
  // Navigation
  activeItemSelector,
  hasOpenedSidebarSelector,
  // props
  propSelector,
} from '../../../selectors';

export default createSelector(
  [
    propSelector,
    activeItemSelector,
    hasOpenedSidebarSelector,
    mainSelect,
    secondarySelect,
  ],
  (props, activeItem, hasOpenedSidebar, main, secondary) => ({
    activeItem,
    hasOpenedSidebar,
    navigationItems: { main, secondary },
    ...props,
  })
);
